import React from 'react'
import {
    GiCandleHolder,
    GiCandleLight,
    GiChaliceDrops,
    GiFamilyHouse,
    GiFireworkRocket,
    GiForkKnifeSpoon,
    GiGraduateCap,
    GiGraveFlowers,
    GiHealing,
    GiHouse,
    GiMoon,
    GiPeaceDove,
    GiPrayerBeads,
    GiSuitcase,
    GiSunrise
} from 'react-icons/gi'

// ─── Kinh Nhật Dụng — bộ kinh ngắn cho đời sống hằng ngày và các hoàn cảnh
// thường gặp (khác nhóm "kinh nguyện truyền thống" như Kinh Mân Côi... vốn là
// những giờ kinh/việc đạo đức trọn vẹn, cần nhiều thời gian hơn). Mỗi kinh có
// 2 bản: short (mặc định — đọc một mình mỗi ngày) / full (đọc chung cộng đoàn).
//
// `daily: true` — đánh dấu kinh phù hợp để lặp lại mỗi ngày theo giờ cố định
// (dùng làm prayer_form cho dropdown "tạo giờ hiệp nguyện", xem usePrayerFormOptions.js).
// Các kinh gắn với hoàn cảnh/sự kiện riêng lẻ (viếng xác, viếng mộ, giỗ, ốm đau,
// hấp hối, đầu năm, đi đường, làm phép nhà, thi cử...) KHÔNG đánh dấu — không phải
// việc đạo đức lặp lại hàng ngày nên không đưa vào dropdown tạo hiệp nguyện định kỳ.

export const STATIC_PRAYER_GROUP = 'daily_prayers'

const iconProps = {size: 22}

export const STATIC_PRAYERS = [
    {
        value: 'morning_offering',
        label: 'morning offering title',
        description: 'morning offering context',
        daily: true,
        duration: 3,
        icon: <GiSunrise {...iconProps}/>,
        color: '#c2740c',
        activeBg: '#fdf1de',
        content: {
            encourage: 'morning offering encourage',
            short: [
                {body: 'morning offering short text'},
            ],
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'glory_be_label', body: 'glory be text'},
                {heading: 'morning offering full heading', body: 'morning offering full text'},
                {heading: 'hope_prayer_label', body: 'we fly to thy patronage text'},
            ],
        },
    },
    {
        value: 'evening_thanksgiving',
        label: 'evening thanksgiving title',
        description: 'evening thanksgiving context',
        daily: true,
        duration: 4,
        icon: <GiMoon {...iconProps}/>,
        color: '#3d5a80',
        activeBg: '#e9f0f7',
        content: {
            encourage: 'evening thanksgiving encourage',
            short: [
                {body: 'evening thanksgiving short text'},
            ],
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'thanksgiving_prayer_label', body: 'thanksgiving prayer text'},
                {heading: 'examination of conscience label', body: 'evening examination text'},
                {heading: 'ea contrition label', body: 'ea contrition text'},
                {heading: 'hope_prayer_label', body: 'we fly to thy patronage text'},
            ],
        },
    },
    {
        value: 'family_evening_prayer',
        label: 'family evening prayer title',
        description: 'family evening prayer context',
        daily: true,
        duration: 18,
        icon: <GiFamilyHouse {...iconProps}/>,
        color: '#8a4b6b',
        activeBg: '#f7ecf2',
        content: {
            encourage: 'family evening prayer encourage',
            short: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'our_father_hail_mary_label', body: ['our father text', 'hail mary text']},
                {heading: 'family intention short label', body: 'family intention short text'},
                {heading: 'hope_prayer_label', body: ['we fly to thy patronage text', 'sign of the cross prayer text']},
            ],
            full: [
                {heading: 'family opening label', body: 'family opening text'},
                {heading: 'family rosary decade label', body: 'family rosary decade text'},
                {heading: 'family intention full label', body: 'family intention full text'},
                {heading: 'thanksgiving_prayer_label', body: 'thanksgiving prayer text'},
                {heading: 'family ancestors label', body: 'family ancestors text'},
                {heading: 'hope_prayer_label', body: 'we fly to thy patronage text'},
                {heading: 'family closing label', body: ['family closing text', 'sign of the cross prayer text']},
            ],
        },
    },
    {
        value: 'wake_visit_prayer',
        label: 'wake visit prayer title',
        description: 'wake visit prayer context',
        duration: 4,
        icon: <GiCandleHolder {...iconProps}/>,
        color: '#5b5f6b',
        activeBg: '#eef0f3',
        content: {
            encourage: 'wake visit prayer encourage',
            short: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'wake visit prayer short text'},
            ],
            // full: đối chiếu thực tế "hát thánh ca là phần quan trọng khi viếng người qua đời tại nhà"
            // (cùng họ kinh cầu hồn với death_anniversary_prayer) — thêm bước hát, tái dùng đúng bài
            // "Từ Chốn Luyện Hình" đã có sẵn lời (key 'anniversary hymn label/text' không riêng cho
            // ngày giỗ, nội dung là thánh ca cầu hồn chung, phù hợp cả viếng xác).
            full: [
                {heading: 'wake opening label', body: ['sign of the cross prayer text', 'wake opening text']},
                {heading: 'depths_prayer_label', body: ['out of the depths text', 'eternal rest prayer text']},
                {heading: 'anniversary hymn label', body: 'anniversary hymn text', type: 'hymn'},
                {heading: 'hope_prayer_label', body: 'we fly to thy patronage text'},
                {heading: 'wake closing label', body: ['wake closing text', 'sign of the cross prayer text']},
            ],
        },
    },
    {
        value: 'grave_visit_prayer',
        label: 'grave visit prayer title',
        description: 'grave visit prayer context',
        duration: 3,
        icon: <GiGraveFlowers {...iconProps}/>,
        color: '#4a6b4f',
        activeBg: '#eaf1eb',
        content: {
            encourage: 'grave visit prayer encourage',
            short: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'grave visit prayer short text'},
            ],
            // full: đối chiếu thực tế "lời kinh và tiếng hát vang lên tại nghĩa trang khi viếng mộ" (nhất
            // là dịp tảo mộ cuối năm) — thêm bước hát, tái dùng đúng bài "Từ Chốn Luyện Hình" như wake
            // visit/death anniversary (cùng họ kinh cầu hồn).
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'depths_prayer_label_short', body: ['out of the depths short text', 'eternal rest prayer text']},
                {heading: 'anniversary hymn label', body: 'anniversary hymn text', type: 'hymn'},
                {heading: 'personal_intention_label', body: 'grave visit prayer full text'},
                {heading: 'hope_prayer_label', body: ['we fly to thy patronage text', 'sign of the cross prayer text']},
            ],
        },
    },
    {
        value: 'death_anniversary_prayer',
        label: 'death anniversary prayer title',
        description: 'death anniversary prayer context',
        // duration ước tính theo bản full (quy ước chung trong file: xem comment đầu file) — bản full nay
        // có trọn 5 chục kinh Mân Côi (Năm Sự Thương) nên tăng hẳn so với 5 phút trước đây.
        duration: 25,
        icon: <GiCandleLight {...iconProps}/>,
        color: '#a15843',
        activeBg: '#faeee9',
        content: {
            encourage: 'death anniversary prayer encourage',
            // Bản rút gọn giữ nguyên — đọc riêng, nhanh, không cần cồng kềnh thêm.
            short: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'death anniversary prayer short text'},
            ],
            // Bản đầy đủ — gia đình sum họp làm giỗ, theo đúng khung "đọc kinh giỗ" phổ biến tại VN
            // (đối chiếu Giáo phận Phan Thiết / ditimchanly.org): Dấu Thánh Giá → hát Kinh Chúa Thánh
            // Thần → Kinh Ăn Năn Tội → Kinh Vực Sâu → lần trọn chuỗi Mân Côi Năm Sự Thương → hát Thánh
            // Ca Cầu Hồn → lời nguyện tưởng nhớ riêng → Kinh Trông Cậy → Dấu Thánh Giá kết.
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'ea holy spirit label', body: 'ea holy spirit text', type: 'hymn'},
                {heading: 'ea contrition label', body: 'ea contrition text'},
                {heading: 'depths_prayer_label', body: ['out of the depths text', 'eternal rest prayer text']},
                {heading: 'anniversary rosary decade label', body: 'anniversary rosary decade text'},
                {heading: 'the agony in the garden', body: 'pray for contrition'},
                {heading: 'the scourging at the pillar', body: 'pray for purity'},
                {heading: 'the crowning with thorns', body: 'pray for moral courage'},
                {heading: 'the carrying of the cross', body: 'pray for patience'},
                {heading: 'the crucifixion', body: 'pray for salvation'},
                {heading: 'anniversary hymn label', body: 'anniversary hymn text', type: 'hymn'},
                {heading: 'anniversary remembrance label', body: 'anniversary remembrance text'},
                {heading: 'hope_prayer_label', body: 'we fly to thy patronage text'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
    {
        value: 'meal_prayer',
        label: 'meal prayer title',
        description: 'meal prayer context',
        daily: true,
        duration: 1,
        icon: <GiForkKnifeSpoon {...iconProps}/>,
        color: '#b3701f',
        activeBg: '#fbf0e1',
        content: {
            encourage: 'meal prayer encourage',
            // Thêm Dấu Thánh Giá ngay trước mỗi lần đọc kinh — đúng thực tế người Công giáo luôn làm
            // dấu trước khi đọc kinh trước/sau bữa ăn (đối chiếu nhiều nguồn: conducmevonhiem.org,
            // vongtayconggiao.vn...), bản cũ thiếu hẳn bước này.
            short: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'before meal label', body: 'before meal text'},
            ],
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'before meal label', body: 'before meal text'},
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'after meal label', body: 'after meal text'},
            ],
        },
    },
    {
        value: 'spiritual_communion',
        label: 'spiritual communion title',
        description: 'spiritual communion context',
        daily: true,
        duration: 2,
        icon: <GiChaliceDrops {...iconProps}/>,
        color: '#8c2f39',
        activeBg: '#f8e9ea',
        content: {
            encourage: 'spiritual communion encourage',
            short: [
                {body: 'spiritual communion short text'},
            ],
            full: [
                {body: 'spiritual communion full text'},
            ],
        },
    },
    {
        value: 'prayer_for_the_sick',
        label: 'prayer for the sick title',
        description: 'prayer for the sick context',
        duration: 2,
        icon: <GiHealing {...iconProps}/>,
        color: '#2f7a68',
        activeBg: '#e7f3f0',
        content: {
            encourage: 'prayer for the sick encourage',
            short: [
                {body: 'prayer for the sick short text'},
            ],
            // full: thêm Dấu Thánh Giá mở/kết cho trang trọng (bản cũ chỉ có 1 đoạn văn trơn), và thêm
            // lời cầu qua Đức Mẹ Hằng Cứu Giúp + Thánh Giuse (quan thầy kẻ liệt) — 2 Đấng hay được cầu
            // khẩn cho người bệnh theo thực tế VN (đối chiếu filumena.net, conggiao.org). Tự soạn ngắn,
            // không chép nguyên văn kinh khấn có sẵn vì chưa tra được bản gốc đủ tin cậy.
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'prayer for the sick full text'},
                {heading: 'prayer for the sick intercession label', body: 'prayer for the sick intercession text'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
    {
        value: 'prayer_for_the_dying',
        label: 'prayer for the dying title',
        description: 'prayer for the dying context',
        duration: 3,
        icon: <GiPrayerBeads {...iconProps}/>,
        color: '#6b3f5f',
        activeBg: '#f4ecf2',
        content: {
            encourage: 'prayer for the dying encourage',
            short: [
                {body: 'prayer for the dying short text'},
            ],
            // full: thêm Dấu Thánh Giá mở đầu (bản cũ thiếu, dù đã có kết) — làm dấu thánh giá trên
            // người hấp hối là cử chỉ thực tế hay làm trước khi đọc lời phó dâng.
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'dying commendation label', body: 'dying commendation text'},
                {heading: 'dying ejaculation label', body: 'dying ejaculation text'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
    {
        value: 'new_year_prayer',
        label: 'new year prayer title',
        description: 'new year prayer context',
        duration: 4,
        icon: <GiFireworkRocket {...iconProps}/>,
        color: '#a8331f',
        activeBg: '#fbeae7',
        content: {
            encourage: 'new year prayer encourage',
            short: [
                {body: 'new year prayer short text'},
            ],
            // full: thêm Dấu Thánh Giá mở/kết, và gợi ý hát Kinh Tạ Ơn (Te Deum) — truyền thống hát cuối
            // năm tại Thánh Lễ Tất Niên VN (đối chiếu xuanbichvietnam.net) — dạng gợi ý, không nhúng lời
            // vì cần bản dịch tiếng Việt đầy đủ mà tôi chưa tra được nguồn đủ tin cậy.
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'new year prayer full text'},
                {heading: 'new year hymn label', body: 'new year hymn text', type: 'hymn'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
    {
        value: 'prayer_for_country',
        label: 'prayer for country title',
        description: 'prayer for country context',
        duration: 2,
        icon: <GiPeaceDove {...iconProps}/>,
        color: '#1f5c8a',
        activeBg: '#e7f0f7',
        content: {
            encourage: 'prayer for country encourage',
            short: [
                {body: 'prayer for country short text'},
            ],
            // full: thêm Dấu Thánh Giá mở/kết cho trang trọng (nội dung chính đã hợp lý — có nhắc Đức Mẹ
            // La Vang, đúng thực tế bổn mạng dân tộc VN, không đổi).
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'prayer for country full text'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
    {
        value: 'travel_prayer',
        label: 'travel prayer title',
        description: 'travel prayer context',
        duration: 2,
        icon: <GiSuitcase {...iconProps}/>,
        color: '#456b8a',
        activeBg: '#e9f1f6',
        content: {
            encourage: 'travel prayer encourage',
            short: [
                {body: 'travel prayer short text'},
            ],
            // full: thêm Dấu Thánh Giá mở/kết (nội dung chính đã hợp lý — có nhắc Thiên Thần Bản Mệnh
            // hộ giữ, đúng thực tế, không đổi).
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'travel prayer full text'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
    {
        value: 'house_blessing_prayer',
        label: 'house blessing prayer title',
        description: 'house blessing prayer context',
        // duration tăng theo bản full mới (xem comment dưới) — từ 1 đoạn văn đơn giản thành đủ khung
        // nghi thức làm phép nhà rút gọn cho gia đình tự đọc.
        duration: 8,
        icon: <GiHouse {...iconProps}/>,
        color: '#4f7a3f',
        activeBg: '#edf4e9',
        content: {
            encourage: 'house blessing prayer encourage',
            short: [
                {body: 'house blessing prayer short text'},
            ],
            // full: bản cũ chỉ có 1 đoạn văn tự soạn, không khớp "Nghi Thức Làm Phép Nhà" thật (đối
            // chiếu cphaco.vn) — nay theo đúng khung rút gọn cho gia đình tự đọc (không có linh mục rảy
            // nước phép): hát mở đầu tùy ý → Dấu Thánh Giá → Kinh Ăn Năn Tội/Tin/Cậy/Mến (tái dùng đúng
            // key có sẵn từ Chầu Thánh Thể, cùng nội dung) → kinh dâng nhà cho Chúa (tái dùng nguyên
            // văn bản full cũ, đổi vai trò thành lời dâng thay vì đứng một mình) → hát Tán Tụng Hồng Ân
            // (gợi ý tên bài, không nhúng lời — chưa tra được bản gốc đủ tin cậy) → kết.
            full: [
                {heading: 'ea holy spirit label', body: 'ea holy spirit text', type: 'hymn'},
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {heading: 'ea contrition label', body: 'ea contrition text'},
                {heading: 'ea faith label', body: 'ea faith text'},
                {heading: 'ea hope label', body: 'ea hope text'},
                {heading: 'ea love label', body: 'ea love text'},
                {heading: 'house blessing dedication label', body: 'house blessing prayer full text'},
                {heading: 'house blessing closing hymn label', body: 'house blessing closing hymn text', type: 'hymn'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
    {
        value: 'exam_prayer',
        label: 'exam prayer title',
        description: 'exam prayer context',
        duration: 2,
        icon: <GiGraduateCap {...iconProps}/>,
        color: '#3f5c8a',
        activeBg: '#e9eef7',
        content: {
            encourage: 'exam prayer encourage',
            short: [
                {body: 'exam prayer short text'},
            ],
            // full: thêm Dấu Thánh Giá mở/kết, và lời cầu qua Thánh Giuse Cupertino — vị thánh vốn học
            // hành khó khăn nhưng vượt qua mọi kỳ thi nhờ cầu nguyện, được Giáo Hội nhận là bổn mạng học
            // sinh sinh viên (đối chiếu Wikipedia tiếng Việt, giaophanvinhlong.net). Tự soạn lời cầu ngắn,
            // không chép kinh cố định nào (chưa xác nhận có bản kinh riêng cho ngài).
            full: [
                {heading: 'sign_of_the_cross', body: 'sign of the cross prayer text'},
                {body: 'exam prayer full text'},
                {heading: 'exam patron label', body: 'exam patron text'},
                {heading: 'prayer_section_closing', body: 'sign of the cross prayer text'},
            ],
        },
    },
]
